import api from '../../../services/api';

/**
 * Fetch a single RFP by ID
 */
export const fetchRFPById = async (rfpId) => {
    return api.get(`/rfp/${rfpId}`);
};

/**
 * Assign a section to a team member (Team Lead)
 */
export const assignSection = async (rfpId, sectionId, assignedToUserId, notes = '') => {
    return api.post(`/rfp/lead/${rfpId}/assign`, {
        section_id: sectionId,
        assigned_to_user_id: assignedToUserId,
        notes,
    });
};

/**
 * Update a section's content
 */
export const updateSection = async (rfpId, sectionId, content) => {
    return api.patch(`/rfp/${rfpId}/section/${sectionId}`, { content });
};

/**
 * Update RFP metadata (key information)
 */
export const updateRFPMetadata = async (rfpId, metadata) => {
    return api.patch(`/rfp/${rfpId}/metadata`, metadata);
};

/**
 * Update commercials cost estimation
 */
export const updateCommercialsCostEstimation = async (rfpId, commercialsData) => {
    return api.put(`/extraction/v1/${rfpId}/commercials/cost-estimation`, commercialsData);
};

/**
 * Update proposal stage
 */
export const updateProposalStage = async (rfpId, stage, notes = '') => {
    return api.patch(`/rfp/${rfpId}/stage`, { stage, notes });
};

/**
 * Approve a section (Team Lead)
 */
export const approveSection = async (rfpId, sectionId) => {
    return api.post(`/rfp/lead/${rfpId}/approve/${sectionId}`);
};

/**
 * Improve a section with AI
 */
export const improveWithAI = async (rfpId, sectionId, prompt) => {
    return api.post(`/rfp/${rfpId}/refine`, { section_id: sectionId, prompt });
};

/**
 * Fetch all proposals
 */
export const fetchAllProposals = async (params = '') => {
    // If params is a string like '?q=test', combine it properly
    const query = params.startsWith('?') ? params : (params ? `?${params}` : '');
    return api.get(`/rfp/all${query}`);
};

/**
 * Delete an RFP
 */
export const deleteRFP = async (rfpId) => {
    return api.delete(`/rfp/${rfpId}`);
};

/**
 * Export queries/clarifications to Excel
 */
export const exportQueriesToExcel = async (rfpId) => {
    return api.get(`/extraction/v1/${rfpId}/export?type=queries&format=xlsx`, {
        responseType: 'blob'
    });
};

/**
 * Fetch documents for a specific RFP
 */
export const fetchRFPDocuments = async (rfpId) => {
    return api.get(`/extraction/v1/documents/${rfpId}`);
};

/**
 * Fetch documents assigned to the current employee
 */
export const fetchMyDocuments = async () => {
    return api.get(`/rfp/employee/v1/my-documents`);
};

/**
 * Fetch assigned users for a specific RFP (Team Lead)
 */
export const fetchAssignedUsers = async (rfpId) => {
    return api.get(`/rfp/lead/${rfpId}/assigned-users`);
};

